import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

import toast from 'react-hot-toast';

const originalFetch = window.fetch;
window.fetch = async (...args) => {
  try {
    const response = await originalFetch(...args);
    
    if (!response.ok) {
      if (response.status >= 400) {
        // Silently ignore 404s for the /status endpoint while Railway is catching up
        if (response.status === 404 && args[0] && typeof args[0] === 'string' && args[0].endsWith('/status')) {
          return response;
        }

        const cloned = response.clone();
        cloned.json().then(data => {
          if (response.status === 401 || response.status === 403) {
            localStorage.removeItem('tt_auth_token');
            localStorage.removeItem('tt_current_user');
            window.location.hash = '/';
            window.location.reload();
            return;
          }
          if (data.details && Array.isArray(data.details)) {
            data.details.forEach((err: any) => {
              if (typeof err === 'string') toast.error(err);
              else if (err.message) toast.error(err.message);
              else toast.error(JSON.stringify(err));
            });
          } else if (data.error && data.message) {
            toast.error(`${data.error}: ${data.message}`);
          } else if (data.error) {
            toast.error(data.error);
          } else if (data.message) {
            toast.error(data.message);
          } else if (response.status === 500) {
            toast.error('Erro interno no servidor ou banco de dados indisponível.');
          } else {
            toast.error(`Erro ${response.status}: Falha na requisição.`);
          }
        }).catch(() => {
          if (response.status === 500) {
            toast.error('Erro interno no servidor ou banco de dados indisponível.');
          }
        });
      }
    }
    
    return response;
  } catch (error) {
    toast.error('Sem conexão com a internet ou servidor fora do ar.');
    throw error;
  }
};


import { ErrorBoundary } from './components/ErrorBoundary.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
